import React, { useState, useRef, forwardRef, useEffect } from 'react';

const RadioButton = forwardRef((props, ref) => {
  const { checked, name, value, onChange, onBlur } = props;
  const refChekbox = useRef();
  const [isFocused, setFoused] = useState(false);

  const handleKeyDown = e => {
    if (e.key != 'Enter') return;
    refChekbox?.current?.click();
  };
  return (
    <div
      onFocus={() => setFoused(true)}
      onBlur={() => setFoused(false)}
      onKeyDown={handleKeyDown}
      tabIndex="0"
      className={`w-5 h-5 rounded-full   flex justify-center items-center cursor-pointer ${
        checked ? 'border-green-800' : 'border-grey-700 '
      } ${isFocused ? 'border-2 border-green-1000' : 'border'}`}
      onClick={() => {
        if (typeof refChekbox?.current?.click == 'function') {
          refChekbox?.current?.click();
        }
      }}
    >
      <input
        tabindex="-1"
        type="radio"
        ref={refChekbox}
        name={name}
        onChange={onChange}
        checked={checked}
        value={value}
        onBlur={onBlur}
        className="w-6 h-6"
        style={{ position: 'absolute', opacity: '0', cursor: 'pointer' ,display:'none' }}
      />
      {
        <div
          className={`w-3  h-3  rounded-full ${
            checked ? 'bg-green-800' : 'bg-grey-700'
          }`}
        ></div>
      }
    </div>
  );
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;
